import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import './analytics.css'
import { useState } from 'react';
import UserActivityDetails from '../../UserActivity/UserActivityDetails';
import { IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

const UserLoginTable = ({ data,dataRange }) => {
  const [pageSize, setPageSize] = React.useState(5);
  const [openUserActivity, setOpenUserActivity] = useState(false);
  const [userDetailsData, setUserDetailsData] = useState('');

  // Define columns for DataGrid
  const columns = [
    { field: 'first_name', headerName: 'First Name', flex: 1, sortable: true },
    { field: 'last_name', headerName: 'Last Name', flex: 1, sortable: true },
    { field: 'company_label', headerName: 'Company', flex: 1, sortable: true },
    { field: 'role_name', headerName: 'Role Name', flex: 1, sortable: true },
    { field: 'document_sent_count', headerName: 'Document Sent Count', flex: 1, sortable: true },
    { field: 'export_summary_count', headerName: 'Document Export Count', flex: 1, sortable: true },
    { field: 'file_download_count', headerName: 'Document Download Count', flex: 1, sortable: true },
    { field: 'login_activity_count', headerName: 'Login Count', flex: 1, sortable: true },
    { field: 'invoice_created_count', headerName: 'Invoice Count', flex: 1, sortable: true },
    {
      field: 'actions', headerName: 'View', flex: 1,
      renderCell: (params) => (
        <>
          <IconButton aria-label="view details" onClick={() => openUserDetailsModal(params.row)}>
            <VisibilityIcon style={{ color: 'black' }} />
          </IconButton>
        </>
      )
    },
    // onClick = {() => openUserDetailsModal(row)}
  ];

  // Add an ID to each row for DataGrid
  const rows = data.map((row, index) => ({ id: index, ...row }));

  const openUserDetailsModal = (data) => {
    setOpenUserActivity(true);
    setUserDetailsData(data);
  }

  const handleClosePdfModal = () => {
    setOpenUserActivity(false);
  };

  return (
    <div style={{ height: 400, width: '100%' }} className='no-border'>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        rowsPerPageOptions={[5, 10, 25]}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        pagination
        sortingOrder={['asc', 'desc']}
      />
      <UserActivityDetails open={openUserActivity} onClose={handleClosePdfModal} userDetailsData={userDetailsData} dataRange={dataRange}/>
    </div>
  );
};

export default UserLoginTable;
